import { Component, OnInit } from '@angular/core'

@Component({
    selector: './drgs-equipment',
    templateUrl: './drgs-equipment.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class DRGSEquipmentComponent implements OnInit {

    ngOnInit() {

    }
}